import { OnChangeFn, PaginationState } from "@tanstack/react-table";

import { PAGE_SIZE } from "components";
import { useRecallsDashboardFilters, useUpdateRecallsDashboardFilters } from "modules/RecallsDashboard/hooks";
import { RECALLS_DASHBOARD_KEYS } from "modules/RecallsDashboard/storageKeys";
import { setPreference } from "util/common";

export const useRecallsDashboardFilterHandlers = () => {
  const {
    data: { page: currentPage, page_size: pageSize }
  } = useRecallsDashboardFilters();
  const updateRecallsDashboardFilters = useUpdateRecallsDashboardFilters();

  const onPageChange = ({ activePage: page }: { activePage: number }) => updateRecallsDashboardFilters({ page });
  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: currentPage - 1, pageSize }) : updater;
    onPageChange({ activePage: newState.pageIndex + 1 });
  };

  const handlePageSizeChange = (page_size: PAGE_SIZE) => {
    setPreference(RECALLS_DASHBOARD_KEYS.PageSizePreference, pageSize);
    updateRecallsDashboardFilters({ page_size, page: 1 });
  };
  const handleSearchTermChange = (term: string) => updateRecallsDashboardFilters({ term, page: 1 });

  return { handlePaginationChange, handlePageSizeChange, handleSearchTermChange };
};
